module.exports = __webpack_public_path__ + "img/08-global-travel.0b857746.jpg";